import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconVerifiedUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "verified_user",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.0007 18.819C8.06079 18.3329 6.46475 17.2114 5.21253 15.4544C3.96016 13.6975 3.33398 11.7635 3.33398 9.65234V4.65234L10.0007 2.15234L16.6673 4.65234V9.65234C16.6673 11.7635 16.0411 13.6975 14.7888 15.4544C13.5366 17.2114 11.9405 18.3329 10.0007 18.819Z",
			fill: "#3B82F6"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M13.834 8.59725L9.09794 13.3333L6.14648 10.3681L7.15336 9.361L9.13961 11.3473L12.8548 7.63184L13.834 8.59725Z",
			fill: "white"
		})]
	})
});
export default SvgIconVerifiedUser;
